import React from 'react';
import { BlogPost } from './types';

export const BlogPostPreview = ({ blogPost }: { blogPost: BlogPost }) => {
  return (
    <div style={{ height: '400px' }}>
      blog post preview for {blogPost.title}
    </div>
  );
};
